// extracted by mini-css-extract-plugin
module.exports = {"Figure":"Image_Figure__83nWV","Image":"Image_Image__5QxS3","Figure--Loading":"Image_Figure--Loading__vwUjT Image_Figure__83nWV"};